// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__RO-UF","row":"Option_row__22Ju7"};